import { render, staticRenderFns } from "./FetchedAddress.vue?vue&type=template&id=70e76414&scoped=true&v-if=fetchedAddress&"
import script from "./FetchedAddress.vue?vue&type=script&lang=js&"
export * from "./FetchedAddress.vue?vue&type=script&lang=js&"
import style0 from "./FetchedAddress.vue?vue&type=style&index=0&id=70e76414&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e76414",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
